import { todo } from "@app/util/todo";

/** Prefixes messages from editor host */
export const HOST_MESSAGE_PREFIX = "cc-editor-host$$"

/** Prefixes messages from editor */
export const EDITOR_MESSAGE_PREFIX = "cc-editor$$"

todo("Add \"null\" as trusted origin to DigitalPayments")

/** Trusted for communicating across boundaries */
export const TRUSTED_ORIGINS: string[] = [
    null, // Needed for mobile
    "null", // Needed for mobile
    "", // Needed for mobile

    "https://localhost:8443",
    "https://localhost:8442",
    "https://localhost:8462",
    "http://localhost:9876",

    "https://propertypay.cit.com",
    "https://www.propertypay.cit.com",
    "https://uatcit-propertypay.cit.com",
    "https://uat-propertypay.firstcitizens.com",
    "https://propertypay.firstcitizens.com"
]
